import {useState} from 'react';
import {updateRepairRequestQuery} from '../models/repair.model';
import {updateRepairInfo} from '../services/repair.service';

export const useUpdateLaptopRepairAsync = () => {
    const [isUpdateRepairLoading, setIsUpdateRepairLoading] = useState<boolean>(false);

    const postRepair = (query: updateRepairRequestQuery) => {
	    setIsUpdateRepairLoading(true);
	    return updateRepairInfo(query).finally(() => {
	        setIsUpdateRepairLoading(false);
        });
    };

    return {
	    postRepair,
	    isUpdateRepairLoading,
    };

};